<template>
    <div class="container-fluid mb-5">
        <div class="row">
            <div class="col-md-12 mt-3 text-center">
                <img class="img-fluid" src="@/assets/logo.png" width="120" alt="">
                <hr />
            </div>
            <div class="col-md-4 mt-2" v-if="level==0">
                <router-link class="card" to="/Home">
                    <div class="card-body">
                        <h4>
                            <span class="mr-1">🏠</span>Home
                        </h4>
                    </div>
                </router-link>
            </div>
            <div class="col-md-4 mt-2" v-if="level==0 | level==1">
                <router-link class="card" to="/Main">
                    <div class="card-body">
                        <h4>
                            <span class="mr-1">🌐</span>My Stations
                        </h4>
                    </div>
                </router-link>
            </div>
            <div class="col-md-4 mt-2" v-if="level==0 | level==1">
                <router-link class="card" to="/nested-stations">
                    <div class="card-body">
                        <h4>
                            <span class="mr-1">🧱</span>Nested stations
                        </h4>
                    </div>
                </router-link>
            </div>
            <div class="col-md-4 mt-2" v-if="level==0 | level==1">
                <router-link class="card" to="/soil-scouts">
                    <div class="card-body">
                        <h4>
                            <span class="mr-1">🌱</span>Soil Scouts
                        </h4>
                    </div>
                </router-link>
            </div>
            <div class="col-md-4 mt-2" v-if="level==0 | level==1">
                <router-link class="card" to="/manual-records">
                    <div class="card-body">
                        <h4>
                            <span class="mr-1">✌️</span>Manual Records
                        </h4>
                    </div>
                </router-link>
            </div>
            <div class="col-md-4 mt-2" v-if="level==0 | level==1">
                <router-link class="card" to="/lightning-strikes">
                    <div class="card-body">
                        <h4>
                            <span class="mr-1">⛅</span>Internet Weather
                        </h4>
                    </div>
                </router-link>
            </div>
            <div class="col-md-4 mt-2" v-if="level==0 | level==1">
                <router-link class="card" to="/droplets">
                    <div class="card-body">
                        <h4>
                            <span class="mr-1">💧</span>Droplets
                        </h4>
                    </div>
                </router-link>
            </div>
            <div class="col-md-4 mt-2" v-if="level==0 | level==2">
                <router-link class="card" to="/qr">
                    <div class="card-body">
                        <h4>
                            <span class="mr-1">📇</span>Inventory
                        </h4>
                    </div>
                </router-link>
            </div>
            <div class="col-md-4 mt-2" v-if="level==0 | level==2">
                <router-link class="card" to="/inventory">
                    <div class="card-body">
                        <h4 class="text-danger">
                            <span class="mr-1">📇</span>Inventory Test
                        </h4>
                    </div>
                </router-link>
            </div>
            <div class="col-md-4 mt-2" v-if="level==0 | level==2">
                <router-link class="card" to="/repairs">
                    <div class="card-body">
                        <h4>
                            <span class="mr-1">🛠️</span>In-Office Work Orders
                        </h4>
                    </div>
                </router-link>
            </div>
            <div class="col-md-4 mt-2" v-if="level==0 | level==2">
                <router-link class="card" to="/field">
                    <div class="card-body">
                        <h4>
                            <span class="mr-1">🌳</span>Field Work Orders
                        </h4>
                    </div>
                </router-link>
            </div>
            <div class="col-md-4 mt-2" v-if="level==0 | level==2">
                <router-link class="card" to="/remote">
                    <div class="card-body">
                        <h4>
                            <span class="mr-1">📱</span>Remote Support
                        </h4>
                    </div>
                </router-link>
            </div>
            <div class="col-md-4 mt-2" v-if="level==0">
                <router-link class="card" to="/Ids">
                    <div class="card-body">
                        <h4>
                            <span class="mr-1">📎</span>API IDs
                        </h4>
                    </div>
                </router-link>
            </div>
            <div class="col-md-4 mt-2" v-if="level==0">
                <div class="card">
                    <div class="card-body">
                        <h4>
                            <a class="nav-link click menu-items" href="#submenu1" data-toggle="collapse" data-target="#submenu1">
                                <span class="mr-1">⚙️</span> Administration
                            </a>
                            <div class="collapse" id="submenu1" aria-expanded="false">
                                <ul class="flex-column pl-2 nav">
                                    <li class="nav-item ml-3">
                                        <router-link class="nav-link click menu-items mt-3" to="/company">
                                            <span class="mr-1">🏢</span>Company
                                        </router-link>
                                    </li>
                                    <li class="nav-item ml-3">
                                        <router-link class="nav-link click menu-items mt-3" to="/users">
                                            <span class="mr-1">👥</span>Users
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </h4>
                    </div>
                </div>
            </div>
            <div class="col-md-4 mt-2" >
                <div class="card" @click="logOut()" >
                    <div class="card-body">
                        <h4>
                            <span class="link d-flex align-items-center justify-content-left">
                                <span class="material-icons md-24 mr-1 text-danger">logout</span>
                                Logout</span>
                        </h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div id="sidebar-container2" v-if="shouldRender">
        <div class="menu mobileMenu">

            <div class="logo mt-3 text-center">
                <img class="img-fluid" src="@/assets/logo.png" width="120" alt="">
                <hr />
            </div>
            <template v-if="level==0">
                <router-link class="nav-link click menu-items" to="/Home">
                    <span class="mr-1">🏠</span>Home
                </router-link>
            </template>
            <template v-if="level==0 | level==1">
                <router-link class="nav-link click menu-items" to="/Main">
                    <span class="mr-1">🌐</span>My Stations
                </router-link>
            </template>
            <template v-if="level==0 | level==1">
                <router-link class="nav-link click menu-items" to="/nested-stations">
                    <span class="mr-1">🧱</span>Nested stations
                </router-link>
            </template>
            <template v-if="level==0 | level==1">
                <router-link class="nav-link click menu-items" to="/manual-records">
                    <span class="mr-1">✌️</span>Manual Records
                </router-link>
            </template>
            <template v-if="level==0 | level==1">
                <router-link class="nav-link click menu-items" to="/lightning-strikes">
                    <span class="mr-1">⛅</span>Internet Weather
                </router-link>
            </template>
            <template v-if="level==0 | level==1">

                <router-link class="nav-link click menu-items" to="/droplets">
                    <span class="mr-1">💧</span>Droplets
                </router-link>
            </template>
            <template v-if="level==0 | level==2">

                <router-link class="nav-link click menu-items" to="/qr">
                    <span class="mr-1">📇</span>Inventory
                </router-link>
            </template>
            <template v-if="level==0 | level==2">

                <router-link class="nav-link click menu-items" to="/repairs">
                    <span class="mr-1">🛠️</span>In-Office Work Orders
                </router-link>
            </template>
            <template v-if="level==0 | level==2">

                <router-link class="nav-link click menu-items" to="/field">
                    <span class="mr-1">🌳</span>Field Work Orders
                </router-link>
            </template>
            <template v-if="level==0">

                <router-link class="nav-link click menu-items" to="/Ids">
                    <span class="mr-1">📎</span>API IDs
                </router-link>
            </template>

            <hr>

            <span @click="logOut()" class="nav-link click menu-items d-flex align-items-center justify-content-left">
                <span class="material-icons md-18 mr-2 text-danger">logout</span>
                Logout</span>
                
            <span class="nav-link click menu-items d-flex align-items-center justify-content-left" @click="closeBar()">
                <span class="material-icons md-18 mr-2">close</span>
                Close menu
            </span>
        </div>
    </div> -->
</template>

<script>
    import { firebaseApp } from "../fb";
    export default {
        name: 'moobileBar',
        props: ['shouldRender'],
        data() {
            return {
                drawer: false,
                direction: 'ltr',
                url: '',
                apiNickname: '',
                user: '',
                name: '',
                apiObject: [],
                apiObjectLength: 0,
                editName: '',
                editApi: '',
                editIndex: '',
                dbname: '',
                dbpass: '',
                dbuser: '',
                lvl: false,
                level: 0,
                apiOrigin: false,
                popupNest: false,
                selectedName: '',
                apiName: '',
                apiValue: '',
                selectedPath: '',
                colorx: '#3DC9B3',
            };
        },
        mounted() {
            this.getInitialData();
            this.selectedPath = this.$route.name
        },
        crated() {
        },
        methods: {
            closeBar() {
                this.$emit('close')
            },
            logOut() {
                this.loading = false
                firebaseApp.auth().signOut()
            },
            getInitialData() {
                var vm = this
                vm.apiObject = []
                firebaseApp.auth().onAuthStateChanged(function (user) {
                    if (!user) {
                        vm.$router.push('/');
                    } else {
                        vm.user = user.uid
                        firebaseApp.database().ref('users/' + user.uid).once("value", function (snapshot) {
                            var data = snapshot.val();
                            vm.name = data.name
                            vm.dbname = data.dbname
                            vm.dbuser = data.dbuser
                            vm.dbpass = data.dbpass
                            vm.level = data.lvl
                            if (data.lvl == 0) {
                                vm.lvl = true
                            }
                            if (data.nestedApi) {
                                vm.apiObject = data.nestedApi
                                vm.apiObjectLength = vm.apiObject.length
                            }
                        }, function (errorObject) {
                            vm.sendNotify(
                                "Error",
                                "Something went wrong",
                                "error",
                                "highlight_off"
                            );
                            return;
                        });
                    }
                });
            },
        },
        watch: {
            $route() {
                const button = this.$refs.menuTop.$el.querySelector(
                    ".vs-navbar--btn-responsive"
                );
                button.click();
            },
        }


    }
</script>